import * as React from "react";
import * as ReactDOM from "react-dom";
import * as moment from "moment/moment.js";

import { TranslationService } from "Services";
import { languages } from "Services/TranslationService.ts";
import LiveChat from "react-livechat";

export default class Footer extends React.Component<FooterProps, {}> {
  links: Object = {
    is: {
      offices: "https://www.samskip.is/skrifstofur/",
      terms:
        "https://www.samskip.is/wp-content/uploads/2026/01/skilmalar_thjonvef_ISL.pdf",
    },
    en: {
      offices: "https://www.samskip.is/en/samskip-offices/",
      terms:
        "https://www.samskip.is/en/wp-content/uploads/sites/9/2026/01/terms_serviceweb_ENG.pdf",
    },
  };
  render() {
    return (
      <footer className="js-MainFooter">
        <div className="MainFooter-container u-posFit">
          <div className="MainFooter-content">
            <div className="MainFooter-info">
              <p>
                © {moment().format("YYYY")} Samskip hf | Kjalarvogur 7-15 | 104
                Reykjavik | {languages("LABEL_ICELAND")}
              </p>
              <p>
                Tel <span> +354 458 8000</span>
              </p>
              <p>
                E-mail
                <span>
                  <a href="mailto:customer.service@samskip.com">
                    {" "}
                    customer.service@samskip.com
                  </a>
                </span>
              </p>
            </div>
            <div className="MainFooter-links">
              <a
                href={this.links[this.props.lang || "is"].offices}
                rel="noopener"
              >
                <span>{languages("FOOTER_OFFICEANDAGENTS")}</span>
              </a>
              <span>|</span>
              <a
                href={this.links[this.props.lang || "is"].terms}
                rel="noopener"
              >
                <span>{languages("FOOTER_TERMS")}</span>
              </a>
            </div>
          </div>
        </div>
        <LiveChat license={12450333} />
      </footer>
    );
  }
}
